export  default {

    reset(state){
        state.chats = [];
        state.messages = [];
    },

    //заполнить данные по web пользователям
    loadChats(state, data) {
        state.chats = data;
    },

    loadChatMessage(state, data) {
        state.messages = data
    },

    putMessage(state, params) {
        //если еще не загружен список чатов, то ничего не делаем (подгрузится потом)
        if (state.chats != null) {
            var chatInd = state.chats.findIndex(x => x.chatId == params.message.chatId)
            if (chatInd != -1) {
                //если есть этот чат, то обновляем счетчик сообщений
                state.chats[chatInd].countNotReadChatMessage = params.CountNotReadChatMessage;
                state.chats[chatInd].lastMessasge = params.message.message;
                //добавляем в список сообщений если есть в стор, в противном случае они подгрузятся
                var ind = state.messages.findIndex(x => x.chatId == params.message.chatId);
                if (ind != -1 && ind != undefined) {
                    state.messages.push(params.message)
                }
            }
        }
    },

    resetMessageCounter(state, chatId) {
        let Ind = state.chats.findIndex(x => x.chatId == chatId)
        if (Ind != -1) {
            state.chats[Ind].countNotReadChatMessage = 0;
        }
    },

}
